import { useLocation, useNavigate } from 'react-router-dom';
import { CopyToClipboard } from "react-copy-to-clipboard";

import './index.css';
import Swal from 'sweetalert2';
import { useFilters } from '../../hooks/useFilters';

type SubcategoryType = {
    id: number;
    name: string;
    img: string;
    code: string;
    parent: string;
    order: number;
}

type HeaderCategoryProps = {
    categories: Array<SubcategoryType>;
    inBlocks?: boolean;
    setInBlocks?: (value: boolean) => void;
    shareContent?: boolean;
    fontColor: string;
    backgroundColor: string;
    categoryId: number;
    clickSubcategory?: (sub: SubcategoryType) => void;
}

export function HeaderMultCategories({ categories, inBlocks, setInBlocks, shareContent, fontColor, backgroundColor, categoryId, clickSubcategory }: HeaderCategoryProps) {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    return (
        <div className='header-category-mult'>
            <div className="header-category-content-mult" style={{backgroundColor: backgroundColor}}>
                <div className="body-mult">
                    <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => navigate(-1)}>
                        <path d="M8 13L2 7L8 1" stroke={fontColor} strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    { clickSubcategory &&
                    <div className="content-mult">
                        { categories.length > 0 ?
                            categories.map((cat, index) => {
                                return(
                                    <div 
                                        onClick={() => clickSubcategory(cat)} 
                                        className='p-content' 
                                        style={cat.id == categoryId ? {color: fontColor, fontWeight: 'bold', fontSize: 14} : {color: fontColor, fontSize: 14}} 
                                        key={index}
                                    >
                                        { cat.name.toUpperCase() }
                                    </div>
                                )
                            }) :
                            <div 
                                onClick={() => {}} 
                                className='p-content' 
                                style={{color: fontColor, fontWeight: 'bold', fontSize: 14}} 
                                key={0}
                            >
                                PESQUISA
                            </div>
                        }
                    </div>
                    }
                    { setInBlocks &&
                    <div className="icons">
                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => setInBlocks(false)}>
                            <rect x="0.5" y="0.5" width="21" height="9" rx="1.5" stroke={!inBlocks ? fontColor : (fontColor+'3F')}/>
                            <rect x="0.5" y="12.5" width="21" height="9" rx="1.5" stroke={!inBlocks ? fontColor : (fontColor+'3F')}/>
                        </svg>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => setInBlocks(true)}>
                            <rect x="1.4502" y="0.5" width="9.15" height="9.15" rx="1.5" stroke={inBlocks ? fontColor : (fontColor+'3F')} />
                            <rect x="13.3502" y="0.5" width="9.15" height="9.15" rx="1.5" stroke={inBlocks ? fontColor : (fontColor+'3F')} />
                            <rect x="1.4502" y="12.75" width="9.15" height="9.15" rx="1.5" stroke={inBlocks ? fontColor : (fontColor+'3F')} />
                            <rect x="13.3502" y="12.75" width="9.15" height="9.15" rx="1.5" stroke={inBlocks ? fontColor : (fontColor+'3F')} />
                        </svg>
                    </div>
                    }
                </div>
                
                { shareContent &&
                    <CopyToClipboard
                        text={window.location.host+pathname}
                        onCopy={() => Swal.fire({
                            icon: 'success',
                            title: 'Produto copiado!',
                            text: 'Link para o produto foi salvo em sua área de transferência.',
                        })}>
                        <div className="icons">
                            <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 14.08C14.24 14.08 13.56 14.38 13.04 14.85L5.91 10.7C5.96 10.47 6 10.24 6 10C6 9.76 5.96 9.53 5.91 9.3L12.96 5.19C13.5 5.69 14.21 6 15 6C16.66 6 18 4.66 18 3C18 1.34 16.66 0 15 0C13.34 0 12 1.34 12 3C12 3.24 12.04 3.47 12.09 3.7L5.04 7.81C4.5 7.31 3.79 7 3 7C1.34 7 0 8.34 0 10C0 11.66 1.34 13 3 13C3.79 13 4.5 12.69 5.04 12.19L12.16 16.35C12.11 16.56 12.08 16.78 12.08 17C12.08 18.61 13.39 19.92 15 19.92C16.61 19.92 17.92 18.61 17.92 17C17.92 15.39 16.61 14.08 15 14.08Z" 
                                fill={fontColor} />
                            </svg>
                        </div>
                    </CopyToClipboard>
                }
            </div>
        </div>
    )
}